<!-- 新房--详情--户型介绍 -->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
      <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>
    <div class="current">
      <div class="item">
        <span class="font-color-gray">当前位置：首页 > 新房 > 户型介绍 > </span>
        <span>{{houseDetailAll.name}}</span>
      </div>
    </div>
    <div class="saleDetail">
      <div class="title">
        <div :class="isIndex == index ? 'title-items' : 'title-item'" v-for="(item, index) in titleList" :key="index" @click="linkPage(item.url, 'id', id)">
          {{ item.typeName }}
        </div>
      </div>
    </div>
    <!-- 全部图片 -->
    <div class="saleImg">
      <div class="title-img">
        <div :class="isImg==index?'img-items':'img-item'"  v-for="(item, index) in imgList" :key="index" @click="linkImg(item,index)">
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="albumItem" v-for="(item, index) in imgswList" :key="index">
      <div class="albums">
        <div class="albums-l">{{item.typeName}} </div>
        <div class="activities-r">
          <!-- <div class="activities-l" v-for="(items, indexs) in item.houseList" :key="indexs" >
            <div class="text"> {{items.name}}</div>
            <div class="xian"> | </div>
          </div> -->
          <div class="more">
            查看更多 >
          </div>
        </div>
      </div>
      <div class="albumsImg">
        <div class="albumsItem"  v-for="(items, indexs) in item.houseList.slice(0,4)" :key="indexs"  @click="saleDetail(items.id)">
          <div class="imgItems">
            <img :src="items.image" alt="" class="imgsw" >
          </div>
            <div class="albumsNames">
              <div class="names">{{items.houseName}}</div>

              <div class="on">{{items.saleStatus}}</div>
              <!-- <div class="zhu" >{{items.mainPushName}}</div> -->
              <div class="zhu" v-if="items.mainPush==0">普通</div>
            <div class="zhu" v-if="items.mainPush==1">主推</div>
            </div>
            <div class="jian">
              建筑面积：{{items.area}}m²
            </div>
            <div class="albumsBut" @click.stop="subscribePhone(item.houseName, '询余房', '')">询余房</div>
        </div>
      </div>
    </div>


    <!-- 楼盘推荐 -->
    <div class="recommend">
      <div class="t flex-b-c">
        <div>楼盘推荐</div>
        <!-- 导航按钮 -->
        <div class="flex-c-c swiper-button-group">
          <div class="btnswiper next next-gray flex-c-c" v-if="flag1"><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper next next-green flex-c-c" v-else><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper prev prev-gray flex-c-c" v-if="flag"><img src="../../../static/pC/prev-1.png" /></div>
          <div class="btnswiper prev prev-green flex-c-c" v-else><img src="../../../static/pC/prev-1.png" /></div>
        </div>
      </div>

      <div class="swiper-container card-carousel-cards">
        <div class="swiper-wrapper">
          <div class="swiper-slide card-carousel--card" v-for="(item, index) in recommendList" :key="index" @click="linkBuildDetail(item.id)">
            <img :src="item.avatar" />
            <div class="n">{{ item.name }}</div>
            <div class="money">{{ item.price }}元/㎡</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 通知表单 -->
    <SanTable :maskShow="maskShow" :houseName="houseName" :whereFrom="whereFrom" :sellId="sellId"></SanTable>

    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from "../../components/HeaderNav";
import FooterNav from "../../components/FooterNav";
import Banners from "../../components/Banners.vue";
import RightNav from '../../components/RightNav.vue';
import SanTable from '../../components/SanTable.vue';
import { getEstateHouse, getHouseList, apiAddNotes } from "../../api/job.js";
import { apigetSetting } from '../../api/login.js';
export default {
  name: "Index",
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    RightNav:RightNav,
    SanTable: SanTable,
  },
  data() {
    return {
      advertInfo: { image: "../../static/pC/ad.png" },
      isIndex:3,
      isImg:0,
      ids:0,
      type:'pc',
      titleList: [
        { typeName: '楼盘首页', url: '/jobDetail' },
        { typeName: '楼盘详情', url: '/SaleDetail' },
        { typeName: '楼盘相册', url: '/BuildImg' },
        { typeName: '户型介绍', url: '/HouseType' },
        { typeName: '用户点评', url: '/evaluate' },
        // { typeName: '周边配套', url: '' },
        { typeName: '楼盘动态', url: '/Dynamics' }
      ],
      imgList:[
        {typeName:'全部户型'},
        {typeName:'一室'},
        {typeName:'二室'},
        {typeName:'三室'},
      ],
      houesList:[
        {name:'一室'},
        {name:'二室'},
        {name:'三室'},
      ],
      recommendList:[],
      houesImgList:[
        {img:'../../../static/pC/qqq.jpg',name:'c2 3室2厅2卫'},
        {img:'../../../static/pC/qqq.jpg',name:'c2 3室2厅2卫'},
      ],
      imgswList:[],
      currentPage: 1, //初始页
      pagesize: 10, //每页的数据
      total: 0, //总数
      page: 1, //第几页
      flag: false, //导航按钮是否到最末尾
      flag1: true, //导航按钮是否到最开头
      id:'',

      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息

      maskShow: false, //通知表单--是否打开
      houseName: '', //通知表单--房子名称
      whereFrom: '', //通知表单--来源
      sellId:'',//通知表单--销售顾问Id
    };
  },
  created(options) {
    this.id = this.$route.query.id;
    this.houseDetailAll = JSON.parse(sessionStorage.getItem('houseDetail'));
    this.judgeLogin();
    this.getAd()
    this.getImg()
  },
  methods: {
    //点击查余房
    subscribePhone(n, type, sellId) {
      // 是否要先登录才能打开通知弹窗
      apigetSetting({}).then(res => {
        if (res.success) {
          var isLoginOpenSanTable = res.data.list.isLogin; //1=》需要，0=》不需要
          if (isLoginOpenSanTable == 0) {
            this.houseName = n;
            this.whereFrom = type;
            this.sellId = sellId;
            this.maskShow = true;
          } else if(isLoginOpenSanTable == 1 ){
            if (this.login == true || this.login == 'true') {
              this.houseName = n;
              this.whereFrom = type;
              this.sellId = sellId;
              this.maskShow = true;
            } else {
              this.$message({ message: '请先登录', type: 'error' });
            }
          }
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
      });
    },

    //关闭通知弹窗
    closeSanTable() {
      this.maskShow = false;
    },

    getAd(){
      this.$loading();
      let  _this = this
      getEstateHouse({
        id:this.id,
      }).then((res) => {
        this.advertInfo = res.data.advertInfo
        this.recommendList = res.data.recommendList;
        this.imgList = res.data.typeInfo
        this.$nextTick(() => {
        //等页面刷新完之后，再执行回调函数中的方法
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: '.prev',
            prevEl: '.next'
          },
          on: {
            slideChangeTransitionEnd: function() {
              if (this.isEnd) {
                _this.flag = true;
              } else {
                _this.flag = false;
              }
              if (this.isBeginning) {
                _this.flag1 = true;
              } else {
                _this.flag1 = false;
              }
            }
          }
        });
        });
        this.$loading().close();
      })
        .catch((err) => {
          this.$loading().close();
        });
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },


    getImg(ids){
      this.$loading();
      getHouseList({
        id:this.id,
        houseType:ids,
        limit:this.pagesize,
        page:this.page,
        type:this.type
      }).then((res) => {
        this.imgswList = res.data.list
        this.$loading().close();
      })
        .catch((err) => {
          this.$loading().close();
        });
    },
    linkDetail(index){
      this.isIndex = index
      if(this.isIndex==0){
         this.$router.push({ path: "/jobDetail" });
      }
      if(this.isIndex==1){
         this.$router.push({ path: "/SaleDetail" });
      }
      if(this.isIndex==2){
         this.$router.push({ path: "/BuildImg" });
      }
      if(this.isIndex==3){
         this.$router.push({ path: "/HouseType" });
      }
    },

    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },


    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
       this.$router.push({ path: url, query: { id: key }},  onComplete => {}, onAbort => {});
      }
    },

    //跳转到户型类型
    saleDetail(id){
      this.$router.push({ path: "/HouseTypeDetail" , query: { id:this.id, typeId:id }});
    },

    //跳转到楼盘详情
    linkBuildDetail(id) {
      this.$router.push({ path: '/jobDetail', query: { id: id } });
    },

    linkImg(item,index){
      this.isImg = index
      this.ids=item.id
      if(this.ids==0){
        this.ids=''
        this.getImg(this.ids)
      }else{
        this.getImg(this.ids)
      }
    }
  }
};
</script>
<style scoped>
/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
/* 当前 */
.current {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  margin-top: 30px;
  border-bottom: 1px solid #e5e5e5;
}
.current .item {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 14px;
}
/* 楼盘详情 */
.saleDetail{
  max-width: 1200px;
  margin: 30px  auto 0 auto;
  display: flex;
}
.saleDetail .title{
  width: 100%;
  background-color: #345c4e;
  color: #fff;
  display: flex;
  align-items: center;
  height: 50px;;
}
.saleDetail .title .title-item{
  width: 130px;
  text-align: center;
  cursor: pointer;
}
.saleDetail .title .title-items{
  width: 130px;
  text-align: center;
  background-color: #A98C60;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
/* 全部图片 */
.saleImg{
  max-width: 1200px;
  margin: 30px  auto 0 auto;
  display: flex;
}
.saleImg .title-img{
  width: 100%;

  display: flex;
  align-items: center;
  height: 50px;;
}
.saleImg .title-img .img-item{
  padding: 0 20px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  border-radius: 20px;
  background-color: #e5e5e5;
  font-size: 16px;
  margin-right: 20px;
}
.saleImg .title-img .img-items{
  padding: 0 20px;
  text-align: center;
  background-color: #345c4e;
  border-radius: 20px;
  color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  margin-right: 20px;
}
/* 一室 */
.albums{
  width: 1200px;
  margin: 30px auto 20px auto;
  display: flex;
  justify-content: space-between;
}
.albums-l{
  font-size: 20px;
  font-weight: bold;
}
.activities-r{
  display: flex;
}
.activities-l{
  display: flex;
  color: #345C4E;
  font-size: 15px;
}
.more{
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.xian{
  margin: 0 20px;
}
.albumsImg{
  width: 1200px;
  margin: 0  auto;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.albumsItem{
  width: 24%;
  padding: 0;
  text-align: center;
  margin-right: 20px;
}
.imgItem{
  width: 280px;
  height: 220px;
}
.imgItems{
  width: 280px;
  height: 280px;
  border: 1px solid #e5e5e5;
}
.imgsw{
  width: 100%;
  height: 100%;
}
.albumsName{
  margin-top: 20px;
}
.albumsNames{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.names{
  font-size: 16px;
  font-weight: bold;
}
.on {
  padding: 0px 5px;
  margin-left: 10px;
  color: #a98c60;
  background-color: #e4dbce;
  font-size: 12px;
}
.zhu {
  padding: 0px 5px;
  margin-left: 5px;
  color: #345c4e;
  border: 1px solid #345c4e;
  font-size: 12px;
}
.jian{
  margin-top: 20px;
}
.albumsBut{
  width: 98%;
  color: #fff;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #345C4E;
  margin-top: 20px;
}


.albumItem{
  width: 1200px;
  margin: 30px auto 20px auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* 楼盘推荐 */
.recommend {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 80px;
}
.recommend .t {
  width: 100%;
  font-size: 22px;
  font-weight: bold;
}
.recommend .swiper-button-group {
}
.recommend .swiper-button-group .btnswiper {
  width: 30px;
  height: 30px;
}
.recommend .swiper-button-group .btnswiper img {
  width: 12px;
  height: 20px;
}
.recommend .swiper-button-group .prev {
  margin-left: 20px;
}
.recommend .swiper-button-group .next-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .next-green {
  background: #345c4e;
}
.recommend .swiper-button-group .prev-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .prev-green {
  background: #345c4e;
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}
.card-carousel-cards .card-carousel--card {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-carousel-cards .card-carousel--card:hover {
  /* box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1); */
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  max-width: 100%;
  height: 227px;
  vertical-align: bottom;
  display: flex;
}
.card-carousel-cards .card-carousel--card img:hover {
  /* opacity: 0.5; */
}
.card-carousel-cards .card-carousel--card .n {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.card-carousel-cards .card-carousel--card .money {
  font-size: 16px;
  font-weight: bold;
  color: #345c4e;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/view/Job/HouseType.vue